import * as PIXI from 'pixi.js';
import { APP_WIDTH, APP_HEIGHT, getProxiedCardImageUrl, CARD_WIDTH, CARD_HEIGHT, redrawFullScreenOverlay } from '../utils/commonUtils';
import AssetsLoader from '../utils/assetsLoader';
import { getGlobalEventEmitter } from '../utils/globalEventEmitter';

import HandContainer from './handContainer';
import CardContainer from './cardContainer';
import ActionButtonsContainer from './actionButtonsContainer';

export default class SearchDeckContainer extends PIXI.Container {
    constructor() {
        super();

        const searchDeckOverlayGraphics = new PIXI.Graphics();
        searchDeckOverlayGraphics.label = 'searchDeckOverlayGraphics';
        searchDeckOverlayGraphics.x = 0;
        searchDeckOverlayGraphics.y = 0;
        searchDeckOverlayGraphics.rect(-APP_WIDTH / 2, -APP_HEIGHT / 2, APP_WIDTH, APP_HEIGHT);
        searchDeckOverlayGraphics.fill({ color: '#000000' });
        searchDeckOverlayGraphics.alpha = 0.7;
        this.addChild(searchDeckOverlayGraphics);

        this.titleText = new PIXI.Text({
            text: 'Pick One Card',
            style: {
                fontFamily: 'Caladea',
                fontWeight: '700',
                fontSize: 90,
                fill: '#ee8d1b',
            },
        });
        this.titleText.anchor.set(0.5, 1);
        this.titleText.x = 0;
        this.titleText.y = -600;
        this.addChild(this.titleText);

        this.subTitleText = new PIXI.Text({
            text: 'Then Select Order',
            style: {
                fontFamily: 'Open Sans',
                fontWeight: '700',
                fontSize: 54,
                fill: '#ffffff',
            },
        });
        this.subTitleText.anchor.set(0.5, 1);
        this.subTitleText.x = 0;
        this.subTitleText.y = -520;
        this.addChild(this.subTitleText);

        const lineGradient = new PIXI.FillGradient({
            type: 'linear',
            start: { x: 0, y: 0.5 },
            end: { x: 1, y: 0.5 },
            colorStops: [
                { offset: 0, color: 'rgba(255, 255, 255, 0)' },
                { offset: 0.25, color: 'rgba(255, 255, 255, 1)' },
                { offset: 0.75, color: 'rgba(255, 255, 255, 1)' },
                { offset: 1, color: 'rgba(255, 255, 255, 0)' },
            ],
        });

        const lineGraphics1 = new PIXI.Graphics();
        lineGraphics1.label = 'lineGraphics1';
        lineGraphics1.x = 0;
        lineGraphics1.y = -500;
        lineGraphics1.rect(-APP_WIDTH / 2 + 50, -2, APP_WIDTH - 100, 4);
        lineGraphics1.fill(lineGradient);
        this.addChild(lineGraphics1);

        this.handContainer = new HandContainer(0, []);
        this.handContainer.label = 'handContainer';
        this.handContainer.scale.set(1.3);
        this.handContainer.x = 0;
        this.handContainer.y = 0;
        this.addChild(this.handContainer);

        this.noCardsFoundText = new PIXI.Text({
            text: 'No Cards Found',
            style: {
                fontFamily: 'Open Sans',
                fontWeight: '700',
                fontSize: 54,
                fill: '#ffffff',
            },
        });
        this.noCardsFoundText.anchor.set(0.5, 0.5);
        this.noCardsFoundText.x = 0;
        this.noCardsFoundText.y = 0;
        this.noCardsFoundText.visible = false;
        this.addChild(this.noCardsFoundText);

        this.singleCardContainer = new CardContainer();
        this.singleCardContainer.label = 'singleCardContainer';
        this.singleCardContainer.x = 0;
        this.singleCardContainer.y = 425;
        this.singleCardContainer.visible = false;
        this.singleCardContainer.scale.set(3);
        this.addChild(this.singleCardContainer);

        this.selectedCardContainer = new CardContainer();
        this.selectedCardContainer.label = 'selectedCardContainer';
        this.selectedCardContainer.x = 0;
        this.selectedCardContainer.y = 0;
        this.selectedCardContainer.visible = false;
        this.selectedCardContainer.scale.set(1.3);
        this.addChild(this.selectedCardContainer);

        this.noSlectionSlotSprite = new PIXI.Sprite(PIXI.Assets.get(AssetsLoader.eDefaultAssetsAliases.NO_SELECTION_SLOT));
        this.noSlectionSlotSprite.anchor.set(0.5, 1);
        this.noSlectionSlotSprite.x = 0;
        this.noSlectionSlotSprite.y = 0;
        this.noSlectionSlotSprite.visible = false;
        this.addChild(this.noSlectionSlotSprite);

        this.reorderTextsContainer = new PIXI.Container();
        this.reorderTextsContainer.visible = false;
        this.addChild(this.reorderTextsContainer);

        const dragToReorderText = new PIXI.Text({
            text: 'Drag to Reorder',
            style: {
                fontFamily: 'Open Sans',
                fontWeight: '700',
                fontSize: 54,
                fill: '#ffffff',
            },
        });
        dragToReorderText.anchor.set(0.5, 1);
        dragToReorderText.x = 0;
        dragToReorderText.y = 100;
        this.reorderTextsContainer.addChild(dragToReorderText);

        const topToBottomText = new PIXI.Text({
            text: 'Top      Bottom',
            style: {
                fontFamily: 'Open Sans',
                fontWeight: '700',
                fontSize: 54,
                fill: '#ffffff',
            },
        });
        topToBottomText.anchor.set(0.5, 1);
        topToBottomText.x = 0;
        topToBottomText.y = 460;
        this.reorderTextsContainer.addChild(topToBottomText);

        const rightArrow = new PIXI.Sprite(PIXI.Assets.get(AssetsLoader.eDefaultAssetsAliases.RIGHT_ARROW));
        rightArrow.anchor.set(0.5);
        rightArrow.x = -50;
        rightArrow.y = 435;
        this.reorderTextsContainer.addChild(rightArrow);

        this.actionButtonsContainer = new ActionButtonsContainer();
        this.actionButtonsContainer.label = 'actionButtonsContainer';
        this.actionButtonsContainer.x = 0;
        this.actionButtonsContainer.y = 650;
        this.addChild(this.actionButtonsContainer);
    }

    rebuildReorderSlots(cards, forceNoSelection) {
        while (this.reorderSlots?.length) {
            const reorderSlot = this.reorderSlots.pop();
            reorderSlot.destroy();
        }

        const cardGap = cards.length <= 5 ? 200 : 150;
        const cardSwitchThreshold = cards.length <= 5 ? 100 : 75;
        const reorderSlotsY = forceNoSelection ? -190 : 250;

        this.reorderSlots = [];
        this.heldCardContainer = null;

        const totalSlots = cards.length;
        for (let i = 0; i < totalSlots; i++) {
            const reorderSlot = new PIXI.Container();
            reorderSlot.x = (i - (totalSlots - 1) / 2) * cardGap;
            reorderSlot.y = reorderSlotsY;
            reorderSlot.zIndex = 100;
            this.addChild(reorderSlot);
            this.reorderSlots.push(reorderSlot);

            const reorderSlotBg = new PIXI.Sprite(PIXI.Assets.get(AssetsLoader.eDefaultAssetsAliases.REORDER_SLOT));
            reorderSlotBg.anchor.set(0.5);
            reorderSlot.addChild(reorderSlotBg);

            const reorderCardContainer = new CardContainer();
            reorderCardContainer.updateCardInstance(cards[i]);
            reorderCardContainer.hidePowerText();
            reorderCardContainer.disableTapping();
            reorderCardContainer.setHighlightSelected();
            reorderCardContainer.label = 'reorderCardContainer';
            reorderCardContainer.x = 0;
            reorderCardContainer.y = 0;
            reorderCardContainer.pivot.set(0, -CARD_HEIGHT / 2);
            reorderCardContainer.scale.set(0.8);
            reorderSlot.addChild(reorderCardContainer);

            reorderCardContainer.eventMode = 'dynamic';
            reorderCardContainer.on('pointerdown', (event) => {
                event.stopPropagation();
                this.heldCardContainer = cards[i];
                reorderCardContainer.parent.zIndex = 200;

                this.reorderSlots.forEach(slot => {
                    slot.getChildByLabel('reorderCardContainer').unhighlightCard();
                });
            });

            reorderCardContainer.on('globalpointermove', (event) => {
                if (this.heldCardContainer !== cards[i]) {
                    return;
                }

                reorderCardContainer.position = event.getLocalPosition(reorderCardContainer.parent);

                if (reorderCardContainer.position.x < -cardSwitchThreshold) {
                    const parentIndex = this.reorderSlots.findIndex(slot => slot === reorderCardContainer.parent);
                    const otherSlot = this.reorderSlots[parentIndex - 1];
                    if (otherSlot) {
                        const otherReorderCardContainer = otherSlot.getChildByLabel('reorderCardContainer');
                        otherSlot.removeChild(otherReorderCardContainer);
                        reorderCardContainer.parent.addChild(otherReorderCardContainer);
                        
                        reorderCardContainer.parent.zIndex = 100;
                        reorderCardContainer.parent.removeChild(reorderCardContainer);
                        otherSlot.addChild(reorderCardContainer);
                        otherSlot.zIndex = 200;

                        reorderCardContainer.position = event.getLocalPosition(reorderCardContainer.parent);

                        const newReorderSlots = this.reorderSlots.map(slot => slot.getChildByLabel('reorderCardContainer').cardInstance);
                        getGlobalEventEmitter().emit('searchDeckReorderSlotsUpdated', newReorderSlots);
                    }
                } else if (reorderCardContainer.position.x > cardSwitchThreshold) {
                    const parentIndex = this.reorderSlots.findIndex(slot => slot === reorderCardContainer.parent);
                    const otherSlot = this.reorderSlots[parentIndex + 1];
                    if (otherSlot) {
                        const otherReorderCardContainer = otherSlot.getChildByLabel('reorderCardContainer');
                        otherSlot.removeChild(otherReorderCardContainer);
                        reorderCardContainer.parent.addChild(otherReorderCardContainer);
                        
                        reorderCardContainer.parent.zIndex = 100;
                        reorderCardContainer.parent.removeChild(reorderCardContainer);
                        otherSlot.addChild(reorderCardContainer);
                        otherSlot.zIndex = 200;

                        reorderCardContainer.position = event.getLocalPosition(reorderCardContainer.parent);

                        const newReorderSlots = this.reorderSlots.map(slot => slot.getChildByLabel('reorderCardContainer').cardInstance);
                        getGlobalEventEmitter().emit('searchDeckReorderSlotsUpdated', newReorderSlots);
                    }
                }
            });

            reorderCardContainer.on('pointerup', (event) => {
                this.heldCardContainer = null;
                reorderCardContainer.parent.zIndex = 100;
                reorderCardContainer.position = { x: 0, y: 0 };

                this.reorderSlots.forEach(slot => {
                    slot.getChildByLabel('reorderCardContainer').setHighlightSelected();
                });
            });

            reorderCardContainer.onCardHeld = () => {
                this.heldCardContainer = null;
                reorderCardContainer.parent.zIndex = 100;
                reorderCardContainer.position = { x: 0, y: 0 };

                this.reorderSlots.forEach(slot => {
                    slot.getChildByLabel('reorderCardContainer').setHighlightSelected();
                });
            }; 
        }
    }

    destroyReorderSlots() {
        while (this.reorderSlots?.length) {
            const reorderSlot = this.reorderSlots.pop();
            reorderSlot.destroy({ children: true });
        }

        this.reorderSlots = [];
        this.heldCardContainer = null;
    }

    update(gameState) {
        if (gameState.pendingAction?.type !== 'EFFECT_STEP_RESOLUTION' || gameState.pendingAction?.expectedResponseType !== 'searchDeck') {
            return;
        }

        const { title, subtitle } = gameState.pendingAction.currentStepData || {};
        this.titleText.text = title || 'Pick One Card';
        this.subTitleText.text = subtitle || 'Then Select Order';

        this.noCardsFoundText.visible = false;

        if (!gameState.clientGameState.searchDeckReorderMode) {
            const { searchCards, validTargetsForCurrentStep } = gameState.pendingAction;
            const { selectedCard } = gameState.clientGameState;

            if (searchCards.length === 0) {
                this.noCardsFoundText.visible = true;
            }

            const playerState = { handCount: searchCards.length, hand: searchCards };
            const singleCard = searchCards[0];

            this.reorderTextsContainer.visible = false;
            this.destroyReorderSlots();
            this.selectedCardContainer.visible = false;
            this.noSlectionSlotSprite.visible = false;
            
            this.handContainer.visible = true;
            if (gameState.clientGameState.searchDeckSingleCardMode) {
                this.handContainer.visible = false;
                this.singleCardContainer.visible = true;
                this.singleCardContainer.updateCardInstance(singleCard);
                this.singleCardContainer.hidePowerText();
            } else {
                this.handContainer.visible = true;
                this.singleCardContainer.visible = false;
                this.handContainer.scale.set(searchCards.length <= 5 ? 1.3 : 1.0);
                this.handContainer.y = 0;
                this.handContainer.updateHand(gameState, playerState, { playableCards: validTargetsForCurrentStep, selectedCard });
            }

            if (selectedCard) {
                this.actionButtonsContainer.update({ clientGameState: { availableActions: ['NO_SELECTION', 'CONFIRM'] } });
            } else {
                this.actionButtonsContainer.update({ clientGameState: { availableActions: ['NO_SELECTION', { type: 'CONFIRM', disabled: true }] } });
            }
            
            this.actionButtonsContainer.y = 650;
        } else {
            const { searchCards, validTargetsForCurrentStep } = gameState.pendingAction;
            const { selectedCard } = gameState.clientGameState;
            const selectedCardInstance = searchCards.find(card => card.instanceId === selectedCard);
            const forceNoSelection = gameState.pendingAction.currentStepData?.details?.forceNoSelection;

            this.handContainer.visible = false;
            this.singleCardContainer.visible = false;

            if (forceNoSelection) {
                this.selectedCardContainer.visible = false;
                this.noSlectionSlotSprite.visible = false;
            } else if (selectedCard) {
                this.selectedCardContainer.visible = true;
                this.selectedCardContainer.updateCardInstance(selectedCardInstance);
                this.selectedCardContainer.hidePowerText();
            } else {
                this.noSlectionSlotSprite.visible = true;
            }

            this.reorderTextsContainer.visible = true;
            if (forceNoSelection) {
                this.reorderTextsContainer.y = -440;
            } else {
                this.reorderTextsContainer.y = 0;
            }

            this.rebuildReorderSlots(gameState.clientGameState.searchDeckReorderSlots, forceNoSelection);

            const availableActions = [];
            if (!forceNoSelection) {
                availableActions.push('RESET');
            }

            if (gameState.clientGameState.searchDeckChooseReorderPosition) {
                availableActions.push('PLACE_ON_TOP', 'PLACE_ON_BOTTOM');
            } else {
                availableActions.push('CONFIRM');
            }

            if (forceNoSelection) {
                this.actionButtonsContainer.y = 250;
            } else {
                this.actionButtonsContainer.y = 650;
            }

            this.actionButtonsContainer.update({ clientGameState: { availableActions } });
        }
    }

    resize(width, height) {
        redrawFullScreenOverlay(this.getChildByLabel('searchDeckOverlayGraphics'), width, height);
    }
}